import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostPassiveAggressiveTextsID() {
  const articleData = {
    title: 'Panduan Utama Teks Pasif-Agresif',
    description: 'Bingung dengan teks yang membuat Anda frustrasi atau kesal? Pelajari cara mengenali pesan pasif-agresif dengan deteksi bertenaga AI dari Toxic Detector.',
    slug: 'ultimate-guide-passive-aggressive-texts',
    publishDate: '2025-05-22',
    author: 'Editorial Toxic Detector'
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'Apa itu teks pasif-agresif?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Teks yang menyampaikan permusuhan, kritik, atau frustrasi secara tidak langsung, seringkali membuat penerima bingung atau kesal.'
      }
    }, {
      '@type': 'Question',
      name: 'Mengapa orang mengirim pesan pasif-agresif?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ini sering kali merupakan cara terselubung untuk mengekspresikan kemarahan, membuat rasa bersalah, atau memanipulasi tanpa konfrontasi terbuka.'
      }
    }, {
      '@type': 'Question',
      name: 'Bisakah AI mendeteksi perilaku pasif-agresif dalam pesan?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Ya. Toxic Detector menganalisis nada, frasa, penggunaan emoji, pola respons, dan sarkasme halus untuk menandai teks manipulatif.'
      }
    }]
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sJh1uV1DahBAgXTJX4idSp/1763121685117.jpg',
    author: {
      '@type': 'Person',
      name: articleData.author
    },
    datePublished: articleData.publishDate,
    url: `https://toxicdetector.com/id/blog/${articleData.slug}`
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText('https://toxicdetector.com/');
      alert('Tautan disalin ke papan klip!');
    }
  };
  return <>
      <MetaTags title="Panduan Utama Teks Pasif-Agresif — Bagaimana AI Mendeteksi Manipulasi | ToxicDetector" description="Bingung dengan teks yang membuat Anda frustrasi? Pelajari cara mengenali pesan pasif-agresif dengan AI." keywords="teks pasif-agresif, perilaku pasif-agresif terselubung, pola manipulasi teks, detektor agresi pasif AI" canonical={`https://toxicdetector.com/id/blog/${articleData.slug}`} ogType="article" ogImage="https://cdn.magicpatterns.com/uploads/rgRp5kcuKrQdAWFQxfbcKt/file_0000000085487243beb3c848ebc5ef15.png" schema={[faqSchema, articleSchema]} data-id="element-7175" />
      <div className="flex flex-col w-full min-h-screen bg-[#fafaf9]" data-id="element-7176">
        <header className="bg-white border-b border-gray-200 sticky top-0 z-50 backdrop-blur-sm bg-white/95" data-id="element-7177">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-7178">
            <div className="flex items-center justify-between" data-id="element-7179">
              <Link to="/" className="text-2xl font-bold tracking-tight" data-id="element-7180">
                🚩 ToxicDetector
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" aria-label="Bagikan artikel" data-id="element-7181">
                <Share2 size={20} data-id="element-7182" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-12" data-id="element-7183">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-10 hover:text-gray-900 transition-colors" data-id="element-7184">
            <ArrowLeft size={16} className="mr-2" data-id="element-7185" />
            Kembali ke Beranda
          </Link>

          <header className="mb-12" data-id="element-7186">
            <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-7187">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-600 text-sm gap-3" data-id="element-7188">
              <time dateTime={articleData.publishDate} data-id="element-7189">
                {new Date(articleData.publishDate).toLocaleDateString('id-ID', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-7190">•</span>
              <span data-id="element-7191">{articleData.author}</span>
            </div>
          </header>

          <div className="mb-12" data-id="element-7192">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sJh1uV1DahBAgXTJX4idSp/1763121685117.jpg" alt="AI menganalisis pesan teks pasif-agresif" className="w-full rounded-2xl shadow-lg" data-id="element-7193" />
          </div>

          <div className="bg-white rounded-2xl p-7 border border-gray-200 mb-12" data-id="element-7194">
            <h2 className="font-bold text-lg mb-5" data-id="element-7195">Daftar Isi</h2>
            <ol className="space-y-3 text-sm list-decimal list-inside" data-id="element-7196">
              <li data-id="element-7197">
                <a href="#sure-whatever" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-7198">
                  Klasik "Tentu, Terserah"
                </a>
              </li>
              <li data-id="element-7199">
                <a href="#backhanded-compliment" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-7200">
                  Pujian Tidak Tulus
                </a>
              </li>
              <li data-id="element-7201">
                <a href="#friendly-reminder" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-7202">
                  "Pengingat Ramah" yang Sebenarnya Sindiran
                </a>
              </li>
              <li data-id="element-7203">
                <a href="#ghostly-reply" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-7204">
                  Balasan Hantu
                </a>
              </li>
              <li data-id="element-7205">
                <a href="#sarcasm-humor" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-7206">
                  Sarkasme yang Disamarkan sebagai Humor
                </a>
              </li>
              <li data-id="element-7207">
                <a href="#conditional-niceness" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-7208">
                  Kebaikan Bersyarat
                </a>
              </li>
              <li data-id="element-7209">
                <a href="#rollercoaster" className="text-gray-700 hover:text-gray-900 transition-colors" data-id="element-7210">
                  Rollercoaster Bolak-Balik
                </a>
              </li>
            </ol>
          </div>

          <div className="prose prose-lg prose-gray max-w-none" data-id="element-7211">
            <p className="text-xl mb-8 leading-relaxed text-gray-700" data-id="element-7212">
              Pernah menerima teks yang membuat Anda mempertanyakan apakah Anda
              bereaksi berlebihan — meskipun itu membuat Anda kesal, frustrasi,
              atau bingung? Itu adalah <strong data-id="element-7213">teks pasif-agresif</strong> yang
              sedang beraksi.
            </p>
            <p className="mb-12 text-lg leading-relaxed text-gray-600" data-id="element-7214">
              <strong data-id="element-7215">Deteksi AI</strong> kami dapat menangkap pola{' '}
              <strong data-id="element-7216">perilaku manipulatif</strong> ini secara instan. Berikut
              adalah panduan utama Anda.
            </p>

            <section id="sure-whatever" className="mb-12" data-id="element-7217">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7218">
                1️⃣ Klasik "Tentu, Terserah"
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-7219">
                <p className="italic text-gray-700 text-lg" data-id="element-7220">
                  "Tentu, apa pun yang membuatmu bahagia..."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7221">
                Sekilas, ini tampak setuju—tetapi di bawahnya? Penolakan atau
                sarkasme. AI menandai frasa ini.
              </p>
            </section>

            <section id="backhanded-compliment" className="mb-12" data-id="element-7222">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7223">
                2️⃣ Pujian Tidak Tulus
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-7224">
                <p className="italic text-gray-700 text-lg" data-id="element-7225">
                  "Wow, kamu benar-benar melakukan itu... bagus untukmu."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7226">
                Terdengar bagus? Tidak juga. Sindiran terselubung seperti ini
                merusak kepercayaan diri Anda.
              </p>
            </section>

            <section id="friendly-reminder" className="mb-12" data-id="element-7227">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7228">
                3️⃣ "Pengingat Ramah" yang Sebenarnya Sindiran
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-7229">
                <p className="italic text-gray-700 text-lg" data-id="element-7230">
                  "Hanya supaya kamu tahu... aku membersihkan seluruh dapur."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7231">
                Teks pasif-agresif sering menyamarkan kritik sebagai info yang
                bermanfaat.
              </p>
            </section>

            <section id="ghostly-reply" className="mb-12" data-id="element-7232">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7233">
                4️⃣ Balasan Hantu
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-7234">
                <p className="italic text-gray-700 text-lg" data-id="element-7235">
                  "K..." atau tidak ada balasan sama sekali
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7236">
                Respons singkat, tertunda, atau hilang dapat menghukum tanpa
                konfrontasi.
              </p>
            </section>

            <section id="sarcasm-humor" className="mb-12" data-id="element-7237">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7238">
                5️⃣ Sarkasme yang Disamarkan sebagai Humor
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-7239">
                <p className="italic text-gray-700 text-lg" data-id="element-7240">
                  "Oh, kamu sangat pintar 😏"
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7241">
                Sarkasme terselubung adalah alat utama. AI kami menangkap
                konteksnya.
              </p>
            </section>

            <section id="conditional-niceness" className="mb-12" data-id="element-7242">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7243">
                6️⃣ Kebaikan Bersyarat
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-7244">
                <p className="italic text-gray-700 text-lg" data-id="element-7245">
                  "Aku akan membantu... jika aku tidak punya rencana."
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7246">
                Orang pasif-agresif menetapkan batasan untuk membuat rasa
                bersalah.
              </p>
            </section>

            <section id="rollercoaster" className="mb-12" data-id="element-7247">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7248">
                7️⃣ Rollercoaster Bolak-Balik
              </h2>
              <div className="bg-gray-50 border-l-4 border-gray-900 p-6 mb-6 rounded-r-xl" data-id="element-7249">
                <p className="italic text-gray-700 text-lg" data-id="element-7250">
                  Tinggi dan rendah yang ekstrem dalam teks
                </p>
              </div>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-7251">
                Nada yang berfluktuasi adalah tanda bahaya untuk perilaku
                manipulatif.
              </p>
            </section>

            <section className="mb-12" data-id="element-7252">
              <h2 className="text-3xl font-bold mb-6 tracking-tight" data-id="element-7253">
                🛡 Cara Melindungi Diri Sendiri
              </h2>
              <ul className="space-y-4 text-lg text-gray-600" data-id="element-7254">
                <li className="flex items-start gap-3" data-id="element-7255">
                  <span className="text-gray-900 font-bold" data-id="element-7256">•</span>
                  <span data-id="element-7257">Percayai insting Anda.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-7258">
                  <span className="text-gray-900 font-bold" data-id="element-7259">•</span>
                  <span data-id="element-7260">Simpan tangkapan layar.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-7261">
                  <span className="text-gray-900 font-bold" data-id="element-7262">•</span>
                  <span data-id="element-7263">Hindari menganalisis teks secara berlebihan.</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-7264">
                  <span className="text-gray-900 font-bold" data-id="element-7265">•</span>
                  <span data-id="element-7266">Gunakan Toxic Detector.</span>
                </li>
              </ul>
            </section>

            <section className="mb-16" data-id="element-7267">
              <h2 className="text-3xl font-bold mb-8 tracking-tight" data-id="element-7268">
                Pertanyaan yang Sering Diajukan
              </h2>
              <div className="space-y-6" data-id="element-7269">
                {faqSchema.mainEntity.map((faq, index) => <div key={index} className="bg-white rounded-xl p-6 border border-gray-200" data-id="element-7270">
                    <h3 className="font-bold text-lg mb-3 text-gray-900" data-id="element-7271">
                      {faq.name}
                    </h3>
                    <p className="text-gray-600 leading-relaxed" data-id="element-7272">
                      {faq.acceptedAnswer.text}
                    </p>
                  </div>)}
              </div>
            </section>
          </div>

          <div className="bg-gray-900 rounded-2xl p-12 text-center text-white mt-16" data-id="element-7273">
            <h2 className="text-3xl font-bold mb-4 tracking-tight" data-id="element-7274">
              💀 Berhenti Menerjemahkan. Mulai Mengetahui.
            </h2>
            <p className="text-gray-300 mb-8 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-7275">
              Berhenti menebak. Unggah teks Anda ke Toxic Detector dan dapatkan
              skor toksisitas instan.
            </p>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/20" data-id="element-7276">
              <p className="font-bold text-xl" data-id="element-7277">
                "🚩 65% agresi pasif terdeteksi — perilaku meremehkan berulang
                ditemukan!"
              </p>
            </div>
            <Link to="/upload" className="inline-block bg-white text-gray-900 px-10 py-4 rounded-xl font-bold text-lg hover:bg-gray-100 transition-colors" data-id="element-7278">
              Pindai Obrolan Anda Sekarang →
            </Link>
          </div>

          <RelatedBlogPosts posts={[{
          title: 'Apakah Mantan Anda Narsisis Terselubung?',
          description: 'Temukan jika mantan Anda menunjukkan tanda-tanda perilaku narsisis terselubung dalam teks.',
          slug: 'is-your-ex-a-covert-narcissist',
          emoji: '🎭'
        }, {
          title: 'Pelajari Tentang Istilah: Narsisme & Gaslighting',
          description: 'Pahami pola narsisme dan gaslighting dalam hubungan.',
          slug: 'narcissism-gaslighting-explained',
          emoji: '💀'
        }]} data-id="element-7279" />

          <div className="mt-12 text-center" data-id="element-7280">
            <button onClick={handleShare} className="inline-flex items-center text-gray-700 hover:text-gray-900 font-medium transition-colors" data-id="element-7281">
              <Share2 size={18} className="mr-2" data-id="element-7282" />
              Bagikan artikel ini
            </button>
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-12 mt-16" data-id="element-7283">
          <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-7284">
            <p className="text-gray-400 text-sm" data-id="element-7285">
              © {new Date().getFullYear()} ToxicDetector. Hak cipta dilindungi
              undang-undang.
            </p>
          </div>
        </footer>
      </div>
    </>;
}